import React from "react";

/**
 * Hero artwork — perfectly static.
 * No hover effects, no mouse tracking, no parallax, no framer-motion animations,
 * no CSS keyframes. Just the PNG (which already bakes in the Plan → Design →
 * Deliver labels, orange, drink and arrows) + a static drop-shadow.
 */
export default function HeroArtwork() {
  return (
    <div
      className="relative w-full pointer-events-none"
      style={{ maxWidth: "clamp(520px, 58vw, 900px)" }}
      data-testid="hero-scene"
    >
      <img
        data-testid="hero-combined-image"
        src="/hero-combined.png"
        alt="Our process: plan, design, deliver"
        draggable={false}
        className="relative block w-full h-auto select-none"
        style={{
          filter: "drop-shadow(0 16px 28px rgba(0,0,0,0.08))",
        }}
      />
    </div>
  );
}
